import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {
  WorkflowId,
  WorkflowInstance,
  WorkflowInstanceConfig,
  WorkflowInstanceId,
} from "common/flowmaster/types/workflow";
import {Uuid} from "common/types";

export type WorkflowInstanceAddAction = {
  type: WorkflowsActionTypes["WORKFLOW_INSTANCE_ADD"]["SUCCESS"];
  payload: {instance: WorkflowInstance; archivedId: WorkflowInstanceId | null};
};

export default function addWorkflowInstance(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_INSTANCE_ADD,
    (
      organisationId: OrganisationId,
      definitionId: WorkflowId,
      name: string,
      config: WorkflowInstanceConfig,
      groupId?: Uuid,
      archiveId?: WorkflowInstanceId,
    ) => {
      return requestor
        .post(
          `${basePath}/organisation/${organisationId}/workflow/${definitionId}/config`,
          {
            config,
            name,
            group_id: groupId,
            archive_id: archiveId,
          },
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
